import { form } from '../../../formState'

import { useOptions } from './hooks/useOptions'
import { useTexts } from './hooks/useTexts'

export function Company() {
  const texts = useTexts()
  const options = useOptions()

  return (
    <form.BulkSelect
      name="companyId"
      mixedLabel={texts.mixed}
      options={options}
      label={texts.company}
      testId="companyId"
    />
  )
}
